export enum EnvironmentType {
  DEV = 1,
  RC = 3,
  PROD = 4
}
